<template>
    <ui-modal
        icon="fal fa-clock"
        :title="modalTitle"
        :load-success="loader.modalSuccess"
        :load="loader.modalLoading"
        :name="modalName"
    >
        <template>
            <div class="area-card">
                <div v-show="loader.body" class="loading-card">
                    <ui-load-indicator bg-color="#e7e9f4" color="#69D296" :h="50" :stroke="8" />
                </div>

                <div v-show="!loader.body" class="body-modal">
                    <ui-input
                        v-model="form.name"
                        :label="`Nome da ${typeOfModal}:`"
                        placeholder="Considere um nome descritivo para a Etapa."
                    />

                    <div v-show="!checked.entry || !checked.exit" class="grid-50">
                        <ui-select-2
                            v-model="form.groups"
                            :data="options.groups"
                            :search="false"
                            :show-footer="false"
                            label="Autorizar perfis:"
                            item-label="name"
                            return-value="id"
                            align="left"
                            multiple
                        />

                        <ui-select-2
                            v-model="form.users"
                            :data="options.users"
                            :show-footer="false"
                            label="Autorizar usuários:"
                            item-label="name"
                            return-value="id"
                            align="right"
                            group-by="type"
                            multiple
                        />
                    </div>

                    <ui-util-box-text-slot title="Ativar Permissões de Entrada">
                        <ui-switch v-model="checked.entry" design="xs" :checked="checked.entry" />
                    </ui-util-box-text-slot>

                    <div class="desc-card pb-2">
                        <span v-if="!checked.entry">
                            Grupos com autorização de entrada:
                            <strong>{{ groupsListString }} </strong> <br />
                            <br />
                            Usuários com autorização de entrada:
                            <strong>{{ usersListString }} </strong>
                        </span>
                        <span v-else>
                            Autorização de entrada:
                            <strong> Todos os grupos e usuários, sem restrições. </strong>
                        </span>
                    </div>

                    <ui-util-box-text-slot title="Ativar Permissões de Saída">
                        <ui-switch v-model="checked.exit" design="xs" :checked="checked.exit" />
                    </ui-util-box-text-slot>

                    <div class="desc-card pb-2">
                        <span v-if="!checked.exit">
                            Grupos com autorização de saída:
                            <strong>{{ groupsListString }} </strong> <br />
                            <br />
                            Usuários com autorização de saída:
                            <strong>{{ usersListString }} </strong>
                        </span>
                        <span v-else>
                            Autorização de saída:
                            <strong> Todos os grupos e usuários, sem restrições. </strong>
                        </span>
                    </div>
                </div>
            </div>
        </template>

        <template #footer>
            <ui-button design="md success" :disabled="!canSubmit" @click="submit">{{
                edit.mode ? `Salvar ${typeOfModal}` : `Criar ${typeOfModal}`
            }}</ui-button>
        </template>
    </ui-modal>
</template>
<script>
	import { uiModal } from '@/components/ui/modal'
	import { uiButton } from '@/components/ui/buttons'
	import { uiInput, uiSelect2, uiSwitch } from '@/components/ui/form'
	import { uiUtilBoxTextSlot } from '@/components/ui/form/util'
	import { uiLoadIndicator } from '@/components/ui'

	import { utilMixin, formMixin, alertMixin } from '@/mixins'
	import { storage } from '@/services/storage'
	import { user, funnel } from '@/services/axios'

	const defaultForm = () => ({
		id: '',
		name: '',
		groups: [],
		users: [],
	})

	const defaultDisabled = () => ({})

	const defaultChecked = () => ({
		entry: false,
		exit: false,
	})

	const defaultEdit = () => ({
		type: '',
		mode: false,
		payload: null,
	})

	const defaultLoader = () => ({
		body: false,
		modalLoading: false,
		modalSuccess: false,
	})

	const defaultOptions = () => ({
		groups: [],
		users: [],
	})

	const defaultLabels = () => ({
		admin: storage.get('label_admin'),
		collaborator: storage.get('label_collaborator'),
		supervisor: storage.get('label_supervisor'),
		manager: storage.get('label_manager'),
		broker: storage.get('label_broker'),
	})

	export default {
		name: 'idleness-rules-modal',
		components: {
			uiModal,
			uiButton,
			uiInput,
			uiSelect2,
			uiSwitch,
			uiUtilBoxTextSlot,
			uiLoadIndicator,
		},

		mixins: [utilMixin, formMixin, alertMixin],

		props: {
			daddyName: {
				type: String,
				required: true,
			},

			modalName: {
				type: String,
				required: true,
			},
		},

		data() {
			return {
				form: { ...defaultForm() },
				disabled: { ...defaultDisabled() },
				checked: { ...defaultChecked() },
				loader: { ...defaultLoader() },
				options: { ...defaultOptions() },
				edit: { ...defaultEdit() },
				labels: { ...defaultLabels() },
				oldForm: {},
				oldChecked: {},
			}
		},

		computed: {
			canSubmit() {
				return (
					!this.loader.body &&
					(this.$mx_isFormChanged || this.isCheckedChanged) &&
					!!this.form.name
				)
			},

			isCheckedChanged() {
				return JSON.stringify(this.checked) != JSON.stringify(this.oldChecked)
			},

			typeOfModal() {
				return this.edit.type == 'stage' ? 'Etapa' : 'Status'
			},

			modalTitle() {
				return this.edit.mode
					? `Edição de ${this.typeOfModal}`
					: `Criação de ${this.typeOfModal}`
			},

			usersListString() {
				return this.listOptionsToString(this.form.users, this.options.users) || 'Nenhum'
			},

			groupsListString() {
				return this.listOptionsToString(this.form.groups, this.options.groups) || 'Nenhum'
			},

			privacy() {
				const check = this.checked
				if (check.entry && !check.exit) return 'public_private'
				if (!check.entry && check.exit) return 'private_public'
				if (!check.entry && !check.exit) return 'private'
				return 'public'
			},

			actualObjectOnModal() {
				const idType = `id_${this.edit.type == 'stage' ? 'etapa' : 'status'}`
				return {
					[idType]: this.form.id,
					name: this.form.name,
					'permissoes-entrada': this.checked.entry ? 'public' : 'private',
					'permissoes-saida': this.checked.exit ? 'public' : 'private',
					'permissoes-grupos': [...this.form.groups],
					'permissoes-usuarios': [...this.form.users],
				}
			},

			validateStatusStage() {
				let statusValidated = []

				if (!this.edit.mode && this.edit.type == 'stage') {
					return statusValidated
				}

				const payStatus =
					this.edit.type == 'stage'
						? this.edit.payload.status
						: this.edit.payload.stage.status

				payStatus.forEach((status) => {
					statusValidated.push({
						id_status: status.id,
						name: status.name,
						'permissoes-entrada': this.validatePermission(status.privacy, 'entry'),
						'permissoes-saida': this.validatePermission(status.privacy, 'exit'),
						'permissoes-grupos': [
							...this.getGroupsPermissions(status.id, 'status', this.options.groups),
						],
						'permissoes-usuarios': this.$mx_hasValue(status.permissions)
							? [...status.permissions.users]
							: [],
					})
				})

				if (this.edit.type == 'status') {
					if (this.edit.mode)
						statusValidated.forEach((status, index) => {
							if (status.id_status == this.form.id)
								statusValidated[index] = { ...this.actualObjectOnModal }
						})
					else statusValidated.push({ ...this.actualObjectOnModal })
				}

				return statusValidated
			},

			validateData() {
				if (this.edit.type == 'stage') {
					return {
						...this.actualObjectOnModal,
						status: this.edit.mode ? [...this.validateStatusStage] : [],
					}
				} else {
					const payStage = this.edit.payload.stage
					return {
						id_etapa: payStage.id,
						name: payStage.name,
						'permissoes-entrada': this.validatePermission(payStage.privacy, 'entry'),
						'permissoes-saida': this.validatePermission(payStage.privacy, 'exit'),
						'permissoes-grupos': [...this.form.groups],
						'permissoes-usuarios': this.$mx_hasValue(payStage.permissions)
							? [...payStage.permissions.users]
							: [],
						status: [...this.validateStatusStage],
					}
				}
			},
		},

		created() {
			this.$root.$on(`modal-open-${this.modalName}`, async (payload) => {
				this.reset()
				this.loader.body = true

				this.edit.payload = payload
				if (payload.type) this.edit.type = payload.type
				if (payload.edit) this.edit.mode = true

				this.options.groups = this.makeGroupOptions((await user.getAll('groups', {})).data)
				this.options.users = this.makeUserOptions((await user.simplifiedUsers()).data)

				if (this.edit.mode) {
					let dataModal = null
					if (this.edit.type == 'stage') dataModal = payload
					else dataModal = payload.status

					this.form.id = dataModal.id
					this.form.name = dataModal.name
					this.setPrivacyChecks(dataModal.privacy)
					this.form.groups = this.getGroupsPermissions(
						dataModal.id,
						this.edit.type,
						this.options.groups,
					)
					this.form.users = this.$mx_hasValue(dataModal.permissions)
						? dataModal.permissions.users
						: []
				}

				this.loader.body = false
				this.$mx_copyOldForm()
				this.copyChecked()
			})
		},

		destroyed() {
			this.$root.$off(`modal-open-${this.modalName}`)
		},

		methods: {
			copyChecked() {
				this.oldChecked = JSON.parse(JSON.stringify(this.checked))
			},

			listOptionsToString(list, options) {
				const listNames = []
				list.forEach((id) => {
					const option = options.find((itemOptions) => itemOptions.id == id)
					if (option) listNames.push(option.name)
				})
				return listNames.join(', ')
			},

			makeGroupOptions(list) {
				const options = []
				list.forEach((item) => {
					if (item.name != 'system') {
						options.push({
							name: item.nameTrans.replace('sentry.group.', ''),
							id: item.id,
							permissions: item.permissions,
						})
					}
				})
				return options
			},

			makeUserOptions(list) {
				const options = []
				let setList = [...new Set(list)]

				setList.forEach((item) => {
					options.push({
						name: item.first_name,
						id: item.user_id,
						type: this.getUserType(item.name),
					})
				})

				return options
			},

			getUserType(string) {
				switch (string) {
					case 'admin':
						return this.labels.admin
					case 'collaborator':
						return this.labels.collaborator
					case 'supervisor':
						return this.labels.supervisor
					case 'manager':
						return this.labels.manager
					case 'broker':
						return this.labels.broker
					default:
						return string
				}
			},

			setPrivacyChecks(privacy) {
				switch (privacy) {
					case 'private':
						this.checked.entry = false
						this.checked.exit = false
						break

					case 'public_private':
						this.checked.entry = true
						this.checked.exit = false
						break

					case 'private_public':
						this.checked.entry = false
						this.checked.exit = true
						break

					default:
						this.checked.entry = true
						this.checked.exit = true
				}
			},

			validatePermission(value, type) {
				switch (value) {
					case 'private':
						return 'private'

					case 'public_private':
						if (type == 'entry') return 'public'
						else return 'private'

					case 'private_public':
						if (type == 'entry') return 'private'
						else return 'public'

					default:
						return 'public'
				}
			},

			getGroupsPermissions(id, type, optionsGroup) {
				const permissions = []
				optionsGroup.forEach((group) => {
					if (group.permissions[`funnel.deal.manage_${type}_${id}`])
						permissions.push(group.id)
				})
				return permissions
			},

			closeModal() {
				this.$root.$emit(`modal-close-${this.modalName}`)
				this.loader.body = true
			},

			reset() {
				this.form = { ...defaultForm() }
				this.loader = { ...defaultLoader() }
				this.disabled = { ...defaultDisabled() }
				this.checked = { ...defaultChecked() }
				this.edit = { ...defaultEdit() }
			},

			async submit() {
				try {
					this.loader.modalLoading = true

					if (this.edit.mode || this.edit.type == 'status')
						await funnel.updateStage(
							this.validateData,
							this.edit.type == 'status' ? this.edit.payload.stage.id : this.form.id,
						)
					else await funnel.createStage(this.validateData)

					setTimeout(() => {
						this.$root.$emit(`${this.daddyName}:update`)
						this.loader.modalSuccess = true
						setTimeout(() => {
							this.closeModal()
						}, 500)
					}, 500)
					//...
				} catch (error) {
					this.$mx_alertThisOnError(error)
					this.loader.modalSuccess = false
				}
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
